import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["placeholder"]

import { nextTick, onMounted, ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchInput',
  props: {
    placeholder: {}
  },
  emits: ["open-sheet"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const q = ref('');
const inputEl = ref<HTMLInputElement | null>(null);

function open() {
    // Pass whatever is typed so far (or empty)
    emit('open-sheet', { q: (q.value || '').trim() });
    // Immediately blur so typing continues in SearchSheet
    nextTick(() => inputEl.value?.blur());
}

// Optional hotkey: "/" opens the sheet
onMounted(() => {
    window.addEventListener('keydown', (e) => {
        const t = e.target as HTMLElement | null;
        if (t && (t.tagName === 'INPUT' || t.isContentEditable)) return;
        if (e.key === '/') {
            e.preventDefault();
            open();
        }
    });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    class: "side-search",
    onSubmit: _withModifiers(open, ["prevent"])
  }, [
    _withDirectives(_createElementVNode("input", {
      ref_key: "inputEl",
      ref: inputEl,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((q).value = $event)),
      class: "search-input",
      type: "text",
      placeholder: _ctx.placeholder,
      onFocus: open,
      onClick: open,
      autocomplete: "off"
    }, null, 40, _hoisted_1), [
      [_vModelText, q.value]
    ])
  ], 32))
}
}

})